<template>
    <footer class="bg-black text-white py-12 print:hidden">

        <div class="max-w-screen-lg mx-auto flex flex-col items-center gap-6 mb-6">
            <!-- Footer Navigation Links -->
            <div v-if="site.navigation?.footer?.length" class="flex items-center gap-6">
                <template v-for="page in site.navigation?.footer">
                    <a class="font-semibold hover:text-[var(--primary-400)] transition-colors"
                       :href="page.url"
                       v-html="(page.navigation_label || page.title)"
                    />
                </template>
            </div>

            <p class="text-center text-sm text-[var(--secondary-400)]">
                &copy; {{ site.name }} &middot; All Rights Reserved
            </p>

            <!-- Social Links -->
            <div v-if="hasSocials" class="flex items-center gap-4">
                <a v-if="site.socials?.x" 
                   :href="getSocialUrl('x', site.socials.x)" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   class="text-white hover:text-[var(--primary-400)] transition-colors"
                   aria-label="X (Twitter)">
                    <i class="fa-brands fa-x-twitter text-xl"></i>
                </a>
                <a v-if="site.socials?.instagram" 
                   :href="getSocialUrl('instagram', site.socials.instagram)" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   class="text-white hover:text-[var(--primary-400)] transition-colors"
                   aria-label="Instagram">
                    <i class="fa-brands fa-instagram text-xl"></i>
                </a>
            </div>
        </div>       

    </footer>
</template>

<script>
export default {
    name: 'SiteFooter',
    data() {
        return {
            site: window.app?.site || {},
        };
    },
    computed: {
        hasSocials() {
            return (this.site.socials?.x || this.site.socials?.instagram);
        },
    },
    methods: {
        getSocialUrl(platform, handle) {
            if (!handle) return '#';
            
            // Remove @ if present and ensure proper URL format
            const cleanHandle = handle.replace('@', '');
            
            switch (platform) {
                case 'x':
                    return `https://x.com/${cleanHandle}`;
                case 'instagram':
                    return `https://instagram.com/${cleanHandle}`;
                default:
                    return '#';
            }
        },
    },
}
</script>
